import { Text, TextProps } from '@chakra-ui/react';
import * as React from 'react';

import { Semibold } from '@/imports/ui/chakra/components/Semibold';

import { IParentPostCommentData } from '../../types';
import { getPostTypeReadableName, getTextContentForPost } from '../../utils';

type IParentPostCommentTextContentProps = {
  data: IParentPostCommentData;
} & TextProps;

export const ParentPostCommentTextContent: React.FC<
  IParentPostCommentTextContentProps
> = (props) => {
  const { data, ...rest } = props;
  const content = getTextContentForPost(data.post);

  return (
    <Text {...rest}>
      <Semibold>{data.firstActor.displayName}</Semibold>{' '}
      {data.numUniqueCommenters > 1
        ? `and ${data.numUniqueCommenters - 1} other${
            data.numUniqueCommenters > 2 ? 's' : ''
          } `
        : ''}
      commented on your {getPostTypeReadableName(data.postType)}
      <Semibold>{`${content ? `: ${content}` : ''}`}</Semibold>
    </Text>
  );
};
